<template>
  <modal
    name="version-modal"
    :resizable="true"
    :height="'auto'"
    :width="'90%'"
    :maxWidth="800"
    :scrollable="true"
  >
    <div class="version-modal-container">
      <!-- Header -->
      <div class="modal-header">
        <button class="close-button" @click="closeModal">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <h2 class="modal-title">📋 Historia wersji</h2>
        <p class="modal-subtitle">Przegląd zmian i ulepszeń w systemie KLIMBUD CRM</p>
      </div>

      <!-- Content -->
      <div class="modal-content">
        <!-- Wersja 3.6 -->
        <div class="version-section current">
          <div class="version-header">
            <span class="version-number">v3.6</span>
            <span class="version-badge">AKTUALNA</span>
          </div>
          <div class="version-description">
            <h4>🔧 Stabilizacja formularzy, limitow i usuwania kontrahentow</h4>
            <ul class="changes-list">
              <li>🔔 Naprawa powiadomien toast: poprawna rejestracja pluginu i obsluga this.$toast</li>
              <li>🧾 Uspojnienie UserSettings: inicjalizacja pol limitow na podstawie userProfile</li>
              <li>📊 Usuniecie sztywnych limitow 500/200 w pobieraniu kontrahentow i instalacji</li>
              <li>🗑️ Dodanie akcji Vuex deleteContractor i naprawa usuwania kontrahenta z modala</li>
              <li>🧩 Poprawka zaleznosci builda: dodanie @popperjs/core</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 3.5 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v3.5</span>
          </div>
          <div class="version-description">
            <h4>⚡ Optymalizacja danych i spójność ofert/płatności</h4>
            <ul class="changes-list">
              <li>🚀 Optymalizacja zapytań Firestore: sortowanie po stronie serwera (`orderBy + limit`)</li>
              <li>📉 Ograniczenie limitów zapytań do wartości zgodnych z regułami bezpieczeństwa</li>
              <li>🔄 Refaktoryzacja WarrantyService: listener `onSnapshot` zamiast pełnych odświeżeń co 30s</li>
              <li>🧠 Ograniczenie N+1 w przypomnieniach gwarancyjnych (cache danych kontrahenta)</li>
              <li>🧾 Naprawa nagłówka oferty: poprawne użycie i zapis pola `offerHeader`</li>
              <li>🔍 Rozszerzenie wyszukiwania o NIP: kontrahenci + wszystkie widoki płatności</li>
              <li>🏢 Wyświetlanie NIP obok ikony dla firm na liście kontrahentów</li>
              <li>🗑️ Naprawa usuwania instalacji w InstallationModalList (prawidłowe ID i zamykanie modalu po usunięciu)</li>
              <li>🧩 Grupowanie instalacji w tabeli serwisu: ten sam kontrahent, adres, telefon lub email</li>
              <li>🖼️ Wizualne ramki grup w przypomnieniach serwisowych + lista „Przy okazji” dla powiązanych instalacji</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 3.4 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v3.4</span>
          </div>
          <div class="version-description">
            <h4>📊 Widoczność danych i optymalizacja ustawień</h4>
            <ul class="changes-list">
              <li>🔢 Dodanie liczników rekordów przy labelach w ustawieniach użytkownika</li>
              <li>💾 Naprawienie lazy loading dla płatności i magazynu w UserSettings</li>
              <li>✨ Count badges z gradientowym stylem przy każdym typie danych</li>
              <li>📈 Wyświetlanie rzeczywistej liczby kontrahentów, instalacji, płatności i magazynu</li>
              <li>⚡ Automatyczne ładowanie danych przy pierwszym wejściu w ustawienia</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 3.3 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v3.3</span>
          </div>
          <div class="version-description">
            <h4>🛠️ Ulepszenia modułu serwisu i gwarancji</h4>
            <ul class="changes-list">
              <li>✉️ Poprawka formatowania nagłówka From w emailach (usunięcie "!!")</li>
              <li>📅 Rozdzielenie daty montażu od ostatniego serwisu w tabelach rocznic</li>
              <li>✏️ Możliwość edytowania daty montażu w modalach instalacji</li>
              <li>🎨 Unifikacja wyglądu InstallationModal i InstallationModalList</li>
              <li>🔘 Dodane przyciski szczegółów (ℹ️) w tabelkach przypomnień i rocznic</li>
              <li>🛠️ Zmiana gwarancji z 1 roku na 3 lata od daty montażu</li>
              <li>📋 Wyświetlanie wszystkich instalacji w przypomnieniach (niezależnie od statusu wysłania)</li>
              <li>🔍 Poprawa logiki filtrowania - instalacje z tego samego dnia teraz się wyświetlają</li>
              <li>📊 Rozszerzone tabele z kolumną akcji (80px width)</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 3.1 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v3.1</span>
          </div>
          <div class="version-description">
            <h4>⚙️ Globalne ustawienia ofert i produktów</h4>
            <ul class="changes-list">
              <li>📝 Konfigurowalne domyślne wartości ofert (nagłówek, tytuł, szczegóły, uwagi)</li>
              <li>💰 Edytor domyślnych cen produktów w ustawieniach użytkownika</li>
              <li>🌐 Globalne ustawienia dla wszystkich użytkowników (Firebase sync)</li>
              <li>🎨 Ulepszone style formularzy - textarea z borderami jak input</li>
              <li>✉️ Poprawka wyświetlania emaila użytkownika z Firebase Auth</li>
              <li>🔔 Naprawiona widoczność powiadomień toast w PaymentModal</li>
              <li>📊 Dodawanie i usuwanie produktów w edytorze domyślnych cen</li>
              <li>💾 Automatyczne ładowanie zapisanych ustawień przy tworzeniu oferty</li>
              <li>🎯 Layout stopki w ustawieniach - przycisk zapisz na środku, wyloguj po prawej</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 3.0 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v3.0</span>
          </div>
          <div class="version-description">
            <h4>🎨 Kompleksowa modernizacja UI/UX</h4>
            <ul class="changes-list">
              <li>✨ Nowoczesny design z gradientami i animacjami</li>
              <li>📱 Pełna responsywność na wszystkich widokach</li>
              <li>🔄 Zintegrowany system nawigacji (HeaderMenu + MainMenu)</li>
              <li>📅 Nowy widok kalendarza spotkań z filtrowaniem</li>
              <li>⚙️ Przeprojektowane ustawienia użytkownika</li>
              <li>🚀 Optymalizacja pobierania danych (cache między zakładkami)</li>
              <li>💬 System powiadomień toast dla akcji</li>
              <li>🔍 Ulepszone wyszukiwanie i filtrowanie</li>
              <li>📊 Karty statystyk na głównych widokach</li>
              <li>🎯 Czytelniejsze menu z lepszymi ikonami</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 2.1 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v2.1</span>
          </div>
          <div class="version-description">
            <ul class="changes-list">
              <li>📅 Wstępne spotkania</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 2.0 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v2.0</span>
          </div>
          <div class="version-description">
            <ul class="changes-list">
              <li>📆 Zakres dat w ofertach</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 1.9 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v1.9</span>
          </div>
          <div class="version-description">
            <ul class="changes-list">
              <li>⚡ Ograniczenie pobierania danych</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 1.8 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v1.8</span>
          </div>
          <div class="version-description">
            <ul class="changes-list">
              <li>✏️ Edycja w Archiwum Ofert</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 1.7 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v1.7</span>
          </div>
          <div class="version-description">
            <ul class="changes-list">
              <li>🗂️ Archiwum Ofert</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 1.6 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v1.6</span>
          </div>
          <div class="version-description">
            <ul class="changes-list">
              <li>📦 Magazyn</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 1.5 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v1.5</span>
          </div>
          <div class="version-description">
            <ul class="changes-list">
              <li>📝 Edycja nagłówków oferty</li>
            </ul>
          </div>
        </div>

        <!-- Wersja 1.4 -->
        <div class="version-section">
          <div class="version-header">
            <span class="version-number">v1.4</span>
          </div>
          <div class="version-description">
            <ul class="changes-list">
              <li>🎨 Kolory serwisów</li>
              <li>📧 Mail przypominający o zaległej płatności</li>
            </ul>
          </div>
        </div>

        <!-- Starsze wersje -->
        <div class="version-section collapsed">
          <div class="version-header">
            <span class="version-number">v1.3.x - v1.2.x</span>
          </div>
          <div class="version-description">
            <ul class="changes-list">
              <li>💰 System płatności</li>
              <li>🔧 Poprawki i usprawnienia</li>
              <li>📄 Generowanie PDF</li>
              <li>👥 Zarządzanie kontrahentami</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  methods: {
    closeModal() {
      this.$modal.hide('version-modal');
    }
  }
};
</script>

<style scoped>
.version-modal-container {
  background: #f8f9fa;
  min-height: 400px;
  margin-top: 80px;
}

/* Header */
.modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 32px 40px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
  position: relative;
}

.close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.modal-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.modal-subtitle {
  margin: 8px 0 0;
  font-size: 14px;
  opacity: 0.95;
  font-weight: 400;
}

/* Content */
.modal-content {
  padding: 24px 40px 40px;
  max-height: 600px;
  overflow-y: auto;
}

.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

/* Version Section */
.version-section {
  background: white;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.version-section:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.version-section.current {
  border: 2px solid #667eea;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.2);
}

.version-section.collapsed {
  opacity: 0.8;
}

/* Version Header */
.version-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.version-number {
  font-size: 18px;
  font-weight: 700;
  color: #667eea;
  padding: 6px 16px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 8px;
  letter-spacing: 0.5px;
}

.version-badge {
  font-size: 11px;
  font-weight: 700;
  color: white;
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  padding: 4px 12px;
  border-radius: 6px;
  letter-spacing: 0.5px;
}

/* Version Description */
.version-description h4 {
  margin: 0 0 12px;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.changes-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.changes-list li {
  padding: 8px 0;
  color: #4a5568;
  font-size: 14px;
  line-height: 1.6;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.changes-list li::before {
  content: '';
  width: 6px;
  height: 6px;
  background: #667eea;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 7px;
}

.version-section.current .changes-list li::before {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

/* Responsive */
@media (max-width: 768px) {
  .modal-header {
    padding: 24px 20px;
  }

  .modal-title {
    font-size: 22px;
  }

  .modal-subtitle {
    font-size: 13px;
  }

  .modal-content {
    padding: 16px 20px 24px;
  }

  .version-section {
    padding: 16px 20px;
  }

  .version-number {
    font-size: 16px;
    padding: 4px 12px;
  }

  .changes-list li {
    font-size: 13px;
  }
}
</style>